import styled from "styled-components";

const FooterWrapper = styled.div`
	font-size: 18px;
	line-height: 1.6;
	padding: 0 20px;
	box-sizing: border-box;
`;

export default function Footer() {
	return <FooterWrapper></FooterWrapper>;
}
